import React from 'react'

import classes from './Divider.module.css'

const Divider = () => {

  return (
    <div className={classes.divider}></div>
  )
}

export default Divider